import { render } from "./DriverDashboard.vue?vue&type=template&id=636e4fe4"
import script from "./DriverDashboard.vue?vue&type=script&lang=js"
export * from "./DriverDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__